<!--
 * @Author: 71
 * @Date: 2026-06-12 10:39:31
 * @LastEditTime: 2026-06-15 10:53:24
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\compoents\model\SchoolConfigModal.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="tenantId"
          label="学校"
        >
          <school-search-select
            v-model="model.tenantId"
            :list="tenantList"
            :disabled="editMode"
          />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="days"
          label="试用天数"
        >
          <a-input-number placeholder="请输入天数" v-model="model.days" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="trialOpenFlag"
          label="会员权限是否开启"
        >
          <a-switch :checked="model.trialOpenFlag == 1" @change="changeOpen"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import moment from 'moment'
import SchoolSearchSelect from '@/comUi/SchoolSearchSelect.vue'

export default {
  name: 'SchoolConfigModal',
  components: {
    SchoolSearchSelect
  },
  data() {
    return {
      editMode: false,
      title: '操作',
      visible: false,
      tenantList: [], // 学校列表（原始完整列表）
      model: {
        tenantId: '',
        days: 0,
        trialOpenFlag: 1, // 试用权限是否开启：0：未开启；1：已开启
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },

      confirmLoading: false,
      validatorRules: {
        tenantId: [{ required: true, message: '请选择学校!' }],
        // 新增days规则，必须大于0
        days: [
          { required: true, message: '请输入试用天数!' }, 
          { validator: (rule, value, callback) => {
            if (value <= 0) {
              callback(new Error('天数必须大于等于0'))
            }
            callback()
          }, trigger: 'change'},
        ]
      },
      url: {
        add: '/schoolTrialMemberConfig/add',
        edit: '/schoolTrialMemberConfig/edit',
      },
    }
  },
  created() {
  },
  methods: {
    changeOpen(checked) {
      // 使用 Vue.set 确保响应式更新
      this.$set(this.model, 'trialOpenFlag', checked ? 1 : 0)
    },
    add() {
      //初始化默认值
      this.edit({})
      this.editMode = false
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.editMode = true
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-input-number {
  width: 100% !important;
}
</style>
